import packageJson from 'package.json';

declare const __sr_config: { commitId: string, builtAt: string };

export const printAppInfo = () => {
    console.log(
        `%cSalesRun App %c${packageJson.version}+${__sr_config.commitId.substring(0, 7)} %c(c) %c${new Date().getFullYear()}`,
        'color: black; font-weight: bold;',
        'color: green; font-weight: bold;',
        'color: black; font-weight: bold;',
        'color: purple; font-weight: bold;',
    );
    console.log(
        `%cBuilt At: %c${__sr_config.builtAt}`,
        'color: black; font-weight: bold;',
        'color: black; font-weight: normal;',
    );
};